import { dispatch } from "hf-rt";

const initialState = {
  isLoading: false,
  isLoadingBanner: false
};

export default {
  name: "loading",
  actions: {
    startLoading: function (bool) {
      dispatch({ type: "START_LOADING", bool });
    },
    startLoadingBanner: function (bool) {
      dispatch({ type: "START_LOADING_BANNER", bool });
    }
  },
  reducers: function (state = initialState, action) {
    switch (action.type) {
      case "START_LOADING":
        return {
          ...state,
          isLoading: action.bool
        };
      case "START_LOADING_BANNER":
        return {
          ...state,
          isLoadingBanner: action.bool
        };
      default:
        return state;
    }
  }
};
